<template>
  <Dialog :visible="visible" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div v-if="!user.edit">{{$t('admin.users.add_dialog_title')}}</div>
      <div v-if="user.edit">{{$t('admin.users.add_dialog_title_edit')}}</div>
    </template>

    <div :class="['irinox-dialog-light-content','layout-content',mode]">
      <div class="irinox-form p-pt-2">
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col-12">
                  <label for="add_dialog_email">{{$t('admin.users.add_dialog_email')}}</label>
                  <InputText id="add_dialog_email" type="email" v-model="user.email" 
                    :placeholder="$t('admin.users.add_dialog_email_ph')"
                    :disabled="email!=null"
                    :class="{'p-invalid':!user.email && submitted}"
                    />
              </div>
              <div class="p-field p-col-12">
                  <label for="add_dialog_role">{{$t('admin.users.add_dialog_role')}}</label>
                  <SelectButton  id="add_dialog_role" v-model="user.role" :options="user.roles" 
                   optionLabel="name" optionValue="code" optionDisabled="disabled" style="min-height: 45px;"/>
              </div>
              <div class="p-field p-col-12">
                  <label for="add_dialog_appliances">{{$t('admin.users.add_dialog_appliances')}}</label>
                  <div @click="openShare"
                    :class="['p-grid','fried-chips',{'fried-chips-selected':appliances!=null&&appliances.length>0},{'p-invalid':(appliances==null||appliances.length==0) && submitted}]">
                    <div class="p-col" style="padding: 5px 10px;">
                      <span v-if="appliances==null || appliances.length==0">
                        {{$t('admin.users.add_dialog_appliances_ph')}}
                      </span>
                      <span v-else>
                        {{$t('admin.users.add_dialog_appliances_selected')}}
                      </span>
                    </div>
                    <div class="p-col-fixed p-d-flex p-ai-center" style="width:60px">
                      <img v-if="appliances==null || appliances.length==0" src="assets/irinox/icons/pop_out.svg" :alt="$t('admin.users.add_dialog_appliances_ph')"/>
                      <img v-else src="assets/irinox/icons/selected.svg" :alt="$t('admin.users.add_dialog_appliances_selected')"/>
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <template #footer>
      <Button :label="$t('laboratories.add_lab_button')" @click="buttonClick"/>
    </template>
  </Dialog>
</template>

<script>
import AccountService from '../service/AccountService';
import { mapGetters } from 'vuex';
export default {
    emits: ['update:visible','click:button','click:open-share','click:open-lab'],
    props: {
      visible: Boolean,
      mode: String,
      appliances: Array,
      email: String,
      role: String,
    },
    data() {
        return {
          submitted: false,
          user: {
            roles: [{
              code: "ADMIN",
              name: "ADMIN"
            },{
              code: "KITCHEN_MANAGER",
              name: "KITCHEN MANAGER"
            }],
            role: "KITCHEN_MANAGER",
            email: null,
            edit: false
          },
          users: [],
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
        }),
    },
    watch: {
      email: "updateEmail",
      role: "updateRoles",
      'user.email': "updateRoles",
    },
    created() {
      this.accountService = new AccountService();
      this.updateEmail();
    },
    methods: {
      updateEmail() {
        this.user.edit = false;
        this.user.email = this.email;
        if(this.email) {
          this.user.edit = true;
        }
      },
      checkEmails(e1, e2) {
        if(e1==null || e2==null) {
          return false;
        }
        return e1.toUpperCase() == e2.toUpperCase();
      },
      updateRoles() {
        if(this.role==null || this.email==null) {
          this.user.roles = [{
              code: "ADMIN",
              name: "ADMIN",
              disabled: false
            },{
              code: "KITCHEN_MANAGER",
              name: "KITCHEN MANAGER",
              disabled: false
            },{
              code: "SERVICE",
              name: "SERVICE PARTNER",
              disabled: true
            }];
          this.user.role = "KITCHEN_MANAGER";
          this.users.forEach(function(u) {
            if(this.checkEmails(u.email,this.user.email)) {
              if(u.role == 'SERVICE') {
                this.user.roles = [{
                    code: "ADMIN",
                    name: "ADMIN",
                    disabled: true
                  },{
                    code: "KITCHEN_MANAGER",
                    name: "KITCHEN MANAGER",
                    disabled: true
                  },{
                    code: "SERVICE",
                    name: "SERVICE PARTNER",
                    disabled: false
                  }];
                this.user.role = "SERVICE";
              } else if(u.role.includes('FACTORY')) {
                this.user.roles = [{
                    code: "ADMIN",
                    name: "ADMIN",
                    disabled: true
                  },{
                    code: "KITCHEN_MANAGER",
                    name: "KITCHEN MANAGER",
                    disabled: true
                  },{
                    code: "SERVICE",
                    name: "SERVICE PARTNER",
                    disabled: true
                  }];
                this.user.role = null;
              } else if(u.role==='SUBSIDIARY') {
                this.user.roles = [{
                    code: "SUBSIDIARY",
                    name: "SUBSIDIARY",
                    disabled: false
                  }];
                this.user.role = "SUBSIDIARY";
              } else {
                this.user.roles = [{
                    code: "ADMIN",
                    name: "ADMIN",
                    disabled: false
                  },{
                    code: "KITCHEN_MANAGER",
                    name: "KITCHEN MANAGER",
                    disabled: false
                  },{
                    code: "SERVICE",
                    name: "SERVICE PARTNER",
                    disabled: true
                  }];
                this.user.role = "KITCHEN_MANAGER";
              }
            }
          }.bind(this));

        } else if(this.role==='USER') {
          this.user.roles = [{
              code: "ADMIN",
              name: "ADMIN",
              disabled: false
            },{
              code: "KITCHEN_MANAGER",
              name: "KITCHEN MANAGER",
              disabled: false
            },{
              code: "SERVICE",
              name: "SERVICE PARTNER",
              disabled: true
            }];
          this.user.role = "KITCHEN_MANAGER";
        } else if(this.role==='SERVICE' || this.role==='SERVICE_SALES') {
          this.user.roles = [{
              code: "ADMIN",
              name: "ADMIN",
              disabled: true
            },{
              code: "KITCHEN_MANAGER",
              name: "KITCHEN MANAGER",
              disabled: true
            },{
              code: "SERVICE",
              name: "SERVICE PARTNER",
              disabled: false
            }];
          this.user.role = "SERVICE";
        } else if(this.role==='SUBSIDIARY') {
          this.user.roles = [{
              code: "SUBSIDIARY",
              name: "SUBSIDIARY",
              disabled: false
            }];
          this.user.role = "SUBSIDIARY";
        } else {
          this.user.roles = [];
          this.user.role = null;
        }
      },
      reloadUsers() {
        if(this.mode==='factory' && !this.role) {
          this.accountService.getFactoryUsers(this.personaltoken)
            .then((data) => {
              if(data.code == '200') {
                this.users = data.body;
                this.updateRoles();
              } else {
                console.error("EXCEPTION "+data);
                this.users = [];
              }
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.users = [];
            });
        }
        if(this.mode==='user' && !this.role) {
          this.accountService.getAllServices(this.personaltoken)
            .then((servicesList) => {
              this.users = [];
              servicesList.forEach(function(s) {
                this.users.push({
                  email: s,
                  role: "SERVICE"
                });
              }.bind(this));
              this.updateRoles();
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.users = [];
            });
        }
      },
      updateVisible(value) {
        if(!value) {
          this.submitted = false;
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {
        this.submitted = true;
        if(!this.user.email || !this.user.role || this.appliances==null || this.appliances.length==0) {
          return;
        }
        this.$emit("click:button", {
          email: this.user.email,
          role: this.user.role
        });
      },
      show() {
        this.submitted = false;
        this.reloadUsers();
      },
      openShare() {
        this.$emit("click:open-share");
      },
    }
}
</script>

<style>

</style>